import { SEARCH_AGGREGATES } from '@/utils/constants'

import FilterBrands from './components/FilterBrands'
import FilterCategory from './components/FilterCategory'
import FilterOnSale from './components/FilterOnSale'
import FilterOperationalModel from './components/FilterOperationalModel'
import FilterOrderBy from './components/FilterOrderBy'
import FilterPrice from './components/FilterPrice'
import FilterTags from './components/FilterTags'

const aggregatesComponents = {
  [SEARCH_AGGREGATES.brands]: FilterBrands,
  [SEARCH_AGGREGATES.categories]: FilterCategory,
  [SEARCH_AGGREGATES.orderBy]: FilterOrderBy,
  [SEARCH_AGGREGATES.priceRanges]: FilterPrice,
  [SEARCH_AGGREGATES.availablePromotions]: FilterOnSale,
  [SEARCH_AGGREGATES.tags]: FilterTags,
  [SEARCH_AGGREGATES.operationalModels]: FilterOperationalModel,
}

export default aggregatesComponents
